import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const NameInput = React.memo(({ initialName, onBlur, error, helperText, checkSpecialChar, onValueChange }) => {
    const [name, setName] = useState(initialName || "");
    const [localError, setLocalError] = useState(false);
    const [speChar, setSpeChar] = useState(false);
    const [isNotEmpty, setIsNotEmpty] = useState(false);

    useEffect(() => {
      setName(initialName || "");
    }, [initialName]);

    useEffect(() => {
      setIsNotEmpty(!!error);
    }, [error]);

    const isTooLong = (val) => val.trim().length > 50;
    const isEmpty = (val) => val.length < 1;

    const handleChange = (e) => {
      const value = e.target.value;
      setIsNotEmpty(isEmpty(value));

      if (isTooLong(value)) {
        setLocalError(true);
        return;
      }

      setLocalError(false);
      setSpeChar(checkSpecialChar(value));
      setName(value);
    };

    const getHelperText = () => {
      if (speChar) return "Cannot contain special characters";
      if (localError) return "Maximum 50 characters allowed";
      if (isNotEmpty) return "Name is required";
      return "";
    };

    return (
      <TextField
        label="Name"
        color="secondary"
        fullWidth
        className="filter-inputs"
        margin="dense"
        variant="outlined"
        size="small"
        value={name}
        onChange={handleChange}
        onBlur={() => onBlur(name.trim())}
        required
        error={isNotEmpty || speChar || localError}
        helperText={getHelperText()}
      />
    );
  }
);

export default NameInput;